<div class="tracking-map-card">
  <div class="tracking-map-header">
    <div class="tracking-map-title">
      <span class="tracking-icon">📍</span>
      <span>Suivi en temps réel</span>
      <span *ngIf="livreurEnMouvement" class="tracking-live-badge">
        <span class="live-dot"></span>LIVE
      </span>
    </div>
    <div class="tracking-map-meta" *ngIf="positionLivreur && derniereMiseAJour">
      <span class="tracking-updated">Mis à jour {{ derniereMiseAJour | date:'HH:mm:ss' }}</span>
      <button type="button" class="btn-maps-link" (click)="ouvrirDansGoogleMaps()" title="Ouvrir dans Google Maps">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
        Google Maps
      </button>
    </div>
  </div>

  <!-- Carte Leaflet -->
  <div class="tracking-map-container" [id]="'tracking-map-' + commandeId"></div>

  <!-- Légende -->
  <div class="tracking-legend">
    <span class="legend-item"><span class="legend-dot depart">D</span> Récupération</span>
    <span class="legend-item"><span class="legend-dot arrivee">A</span> Livraison</span>
    <span class="legend-item" *ngIf="positionLivreur"><span class="legend-dot livreur">🚴</span> Livreur</span>
  </div>

  <!-- État de la position -->
  <div *ngIf="!livreurEnMouvement" class="tracking-info-msg tracking-info-idle">
    Suivi GPS actif uniquement pendant la livraison en cours.
  </div>
  <div *ngIf="livreurEnMouvement && positionIndisponible" class="tracking-info-msg tracking-info-warn">
    Position livreur indisponible — en attente de signal GPS...
  </div>
  <div *ngIf="livreurEnMouvement && positionLivreur" class="tracking-coords">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 0 0-8 8c0 5.4 7.05 11.5 7.72 12.07a.5.5 0 0 0 .56 0C12.95 21.5 20 15.4 20 10a8 8 0 0 0-8-8z"/></svg>
    {{ positionLivreur.latitude | number:'1.4-6' }}, {{ positionLivreur.longitude | number:'1.4-6' }}
  </div>
</div>
